import { useEffect } from "react";
import termsMd from "../content/policies/terms.md?raw";
import { renderMarkdown } from "../lib/markdown";
import { EditorialPage } from "../components/editorial";
import Navbar from "../components/Navbar";
import StoryPageHero from "../components/story/StoryPageHero";

// does it: a hardcoded header silently outlives the document. This one already
// had — the terms went to v2.2 on 2026-07-28 while this header still announced
// v2.0 from 2026-05-25, so the live page contradicted its own body.

export default function TermsPage() {
  useEffect(() => {
    document.title = "Terms of Service | LetsLoop";
  }, []);

  return (
    <>
      <Navbar />
      <EditorialPage>
        {/* Header band only. The policy body deliberately keeps its plain
            styling: these pages are read for meaning under pressure, and
            decorating running legal text makes it harder, not better. One
            doodle, no colour grounds, no marker slabs. */}
        <StoryPageHero
          kicker="terms"
          title={<>The agreement, in plain English.</>}
          marks={[
            {
              name: "loop",
              size: 58,
              rotate: 8,
              className: "right-[8%] top-[30%] text-teal/25",
            },
          ]}
        />

        <article className="relative max-w-3xl mx-auto px-4 md:px-6 pt-4 pb-16 md:pb-24">
          {renderMarkdown(termsMd)}
        </article>
      </EditorialPage>
    </>
  );
}
